import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.086 16.215a4.086 4.086 0 1 0-8.172 0c0 4.767-2.044 6.13-2.044 6.13h12.26s-2.044-1.363-2.044-6.13M19.178 25.069a1.362 1.362 0 0 1-2.356 0" }, null, -1)
  ])))
}
export default { render: render }